module.exports = __webpack_public_path__ + "assets/img/footer_logo_4.37f76dc5.png";